export enum Edition {
  Express,
  Pro,
}

export function getEditionFromId(editionId: string | null | undefined): Edition {
  // Only an explicit 'pro' edition has the custom email-domain entitlement. Everything
  // else — Express/Standard, Starter (no edition), or any unknown value — must resolve to
  // Express so callers don't attempt Pro-only operations like reading the email domain.
  // Starter accounts have no edition set, so the previous "anything but 'express' is Pro"
  // fallback misclassified them as Pro and triggered a 403 GetEmailDomain call that hung
  // the template editor.
  return editionId === 'pro' ? Edition.Pro : Edition.Express;
}
